module.exports = __webpack_public_path__ + "img/bg_question_des_4.9da628ba.jpg";